"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTenantUserResponseDto = void 0;
/**
 * A lightweight version of TenantUserResponseDto. See TenantUserResponseDto for more type information
 */
class AuthTenantUserResponseDto {
}
exports.AuthTenantUserResponseDto = AuthTenantUserResponseDto;
